module.exports = __webpack_public_path__ + "img/layout-2.4a636a09.jpg";